<template>
  <!--单选题 [判断-->
  <div @click="setEditIndex(index)">
    <el-row :gutter="10" style="margin-left: 5px">
      <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
        {{number}}
      </el-col>
      <el-col
        :xs="15"
        :sm="15"
        :md="15"
        :lg="15"
        :xl="15"
        class="item_container_title"
      >
        <el-input
          placeholder="请输入题目内容"
          @focus="showAdvance"
          @blur="updateQuestion()"
          v-model="question.questionsName"
          autosize
          onmouseover="this.title=this.value"
        ></el-input>
      </el-col>
      <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
        <i
          class="el-icon-delete delete"
          v-if="index == editIndex"
          @click="questiondel(question.id)"
        ></i>
        <el-badge 
          v-if="question.displayscriptcount || question.jumpscriptcount" 
          :value="question.displayscriptcount + question.jumpscriptcount" 
          class="item">
          <i
            class="el-icon-share"
            @click="()=>$emit('jumpshow',question.id)"
          ></i>
        </el-badge>
        <i class="el-icon-rank item drag-handle"></i>
      </el-col>
    </el-row>
    <el-row
      :gutter="10"
      style="margin-top: 12px !important"
      v-for="(childItem, childindex) in question.optionList"
      :key="index + '_' + childindex"
    >
      <div @click="setEditOptionIndex(childindex)" style="margin-left: 50px">
        <el-col
          :xs="16"
          :sm="16"
          :md="16"
          :lg="16"
          :xl="16"
          class="el_item_option item_container_title"
        >
          <el-radio label="1">
            {{ childItem.labelName }}
            <!-- <el-input placeholder="选项1"
                                  @focus="showAdvance" v-model="childItem.labelName" @blur="wjupdoption(childItem)"></el-input> -->
          </el-radio>
        </el-col>
      </div>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      editOptionIndex: "0_0",
    };
  },
  props: {
	  number: { type: Number, default: 0 },
    question: {},
    editIndex: { type: Number, default: 0 },
    isExistPage: { type: Boolean, default: false },
    index: { type: Number, default: 0 },
  },
  methods: {
    wjupdoption(item) {
      this.$emit("wjupdoption", item);
    },
    updateQuestion() {
      this.$emit("wjupdquestionoption", this.question);
    },
    wjaddquestionoption(optionList, item, type = 1) {
      this.$emit("wjaddquestionoption", optionList, item, type);
    },
    showAdvance(e) {
      this.$emit("showAdvance", e);
    },
    setEditIndex(index) {
      this.$emit("setEditIndex", index);
    },
    setEditOptionIndex(childIndex) {
      this.editOptionIndex = this.editIndex + "_" + childIndex;
    },
    wjdelquestionoption(options, item, childindex) {
      this.$emit("wjdelquestionoption", options, item, childindex);
    },
    questiondel(id) {
      this.$emit("questiondel", id);
    },
  },
  created() {},
};
</script>

<style scoped>
.delete,.item {
  font-size: 22px !important;
  line-height: 40px !important;
  margin-right: 30px !important;
  text-align: right;
  float: right;
  cursor: pointer;
}
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
.el_item_option {
  line-height: 40px;
  height: 44px;
}

.el-icon-common {
  margin-right: 23px;
  font-size: 16px !important;
  line-height: 40px !important;
  color: cornflowerblue;
  cursor: pointer;
}

.el-icon-common-option {
  margin-left: 20px;
  font-size: 22px !important;
  line-height: 40px !important;
  color: cornflowerblue;
  cursor: pointer;
}

.askxh {
  line-height: 40px;
  text-align: right;
}

.item_container_title {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.item_container_title:hover {
  //border: 1px darkgrey dashed;
}
</style>
